import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { DropdownH } from 'components/rfs-ui';

import { ROUTES_WAYS } from 'constants/routesWays';
import { PTMatch } from 'propTypes';

import Links from '../Links/Links';

import styles from './LinkSelect.scss';

const LinkSelect = ({ match }) => {
  const isControlIndicators = match.path === ROUTES_WAYS.CONTROL_INDICATORS;

  return (
    <DropdownH
      contentClassName={styles.dropContent}
      containerClassName={styles.dropContainer}
      title={isControlIndicators ? 'Стратегия 2030' : 'Паспортизация'}
      iconPosition="right"
      size={5}
      center
      className={styles.title}
      closeOnClickOutside
    >
      <Links variant="dropdown" />
    </DropdownH>
  );
};

LinkSelect.propTypes = {
  match: PropTypes.shape(PTMatch).isRequired,
};

export default withRouter(LinkSelect);
